import React from "react";
import { Field } from "formik";
import IdentificationDetailsKeCi from "./IdentificationDetailsKeCi";
import IdentificationDetailsFormFoRe from "./IdentificationDetailsFormFoRe";
import IdentificationDetailsFormFo from "./IdentificationDetailsFormFo";
import IdentificationDetailsFormMi from "./IdentificationDetailsFormMi";
import IdentificationDetailsFormGuardian from "./IdentificationDetailsFormGuardian";
import IdentificationDetailsFormLoCo from "./IdentificationDetailsFormLoCo";
import IdentificationDetailsFormFoCo from "./IdentificationDetailsFormFoCo";
import IdentificationDetailsOther from "./IdentificationDetailsOther";
import IdentificationDetailsCompanyContactPerson from "./IdentificationDetailsCompanyContactPerson";
import IdentificationDetailsCompanySecretaryKeCi from "./IdentificationDetailsCompanySecretaryKeCi";
import IdentificationDetailsCompanySecretaryFoRe from "./IdentificationDetailsCompanySecretaryFoRe";

const IdentificationDetailsForm = (props) => {
  const { idType, designation } = props;
  if (idType && !designation) {
    return (
      <>
        {idType === "Kenyan Citizen" && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsKeCi}
            {...props}
          />
        )}
        {idType === "Foreign Resident" && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsFormFoRe}
            {...props}
          />
        )}
        {idType === "Foreigner" && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsFormFo}
            {...props}
          />
        )}
        {idType === "Minor" && (
          <>
            <Field
              name="identificationDetails"
              component={IdentificationDetailsFormMi}
              {...props}
            />
            <Field
              name="identificationDetails"
              component={IdentificationDetailsFormGuardian}
              {...props}
            />
          </>
        )}
        {idType === "Local Company" && (
          <>
            <Field
              name="identificationDetails"
              component={IdentificationDetailsFormLoCo}
              {...props}
            />
          </>
        )}
        {idType === "Foreign Company" && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsFormFoCo}
            {...props}
          />
        )}
        {idType === "Other e.g Parastatals" && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsOther}
            {...props}
          />
        )}
        {/* Company Contact Person */}
        {["Local Company", "Foreign Company", "Other e.g Parastatals"].includes(
          idType
        ) && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsCompanyContactPerson}
            {...props}
          />
        )}
      </>
    );
  }

  return (
    <div>
      {idType === "Kenyan Citizen" && (
        <>
          {[
            "Director",
            "Authorized Person",
            "Director Shareholder",
            "Shareholder",
            "Joint Shareholder",
          ].includes(designation) ? (
            <Field
              name="identificationDetails"
              component={IdentificationDetailsKeCi}
              {...props}
            />
          ) : (
            designation === "Company Secretary" && (
              <Field
                name="identificationDetails"
                component={IdentificationDetailsCompanySecretaryKeCi}
                {...props}
              />
            )
          )}
        </>
      )}
      {idType === "Foreign Resident" &&
        ([
          "Director",
          "Authorized Person",
          "Director Shareholder",
          "Shareholder",
          "Joint Shareholder",
        ].includes(designation) ? (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsFormFoRe}
            {...props}
          />
        ) : (
          designation === "Company Secretary" && (
            <Field
              name="identificationDetails"
              component={IdentificationDetailsCompanySecretaryFoRe}
              {...props}
            />
          )
        ))}
      {idType === "Foreigner" &&
        [
          "Director",
          "Authorized Person",
          "Director Shareholder",
          "Shareholder",
          "Joint Shareholder",
        ].includes(designation) && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsFormFo}
            {...props}
          />
        )}
      {idType === "Local Company" &&
        [
          "Director",
          "Authorized Person",
          "Company Secretary",
          "Director Shareholder",
          "Shareholder",
        ].includes(designation) && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsFormLoCo}
            {...props}
          />
        )}
      {idType === "Foreign Company" &&
        [
          "Director",
          "Authorized Person",
          "Director Shareholder",
          "Shareholder",
        ].includes(designation) && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsFormFoCo}
            {...props}
          />
        )}
      {idType === "Minor" &&
        ["Shareholder", "Joint Shareholder"].includes(designation) && (
          <>
            <Field
              name="identificationDetails"
              component={IdentificationDetailsFormMi}
              {...props}
            />
            <Field
              name="identificationDetails"
              component={IdentificationDetailsFormGuardian}
              {...props}
            />
          </>
        )}
      {idType === "Other e.g Parastatals" &&
        [
          "Director",
          "Authorized Person",
          "Director Shareholder",
          "Shareholder",
        ].includes(designation) && (
          <Field
            name="identificationDetails"
            component={IdentificationDetailsOther}
            {...props}
          />
        )}
      {/* Company Contact Person */}
      {["Local Company", "Foreign Company", "Other e.g Parastatals"].includes(
        idType
      ) && (
        <Field
          name="identificationDetails"
          component={IdentificationDetailsCompanyContactPerson}
          {...props}
        />
      )}
    </div>
  );
};

export default IdentificationDetailsForm;
